import React from 'react';

interface DateRangePickerProps {
  startDate: string | null;
  endDate: string | null;
  onDateRangeChange: (startDate: string | null, endDate: string | null) => void;
  startDateLabel?: string;
  endDateLabel?: string;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onDateRangeChange,
  startDateLabel = 'Start Date',
  endDateLabel = 'End Date',
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <div className="w-full sm:w-1/2">
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          {startDateLabel}
        </label>
        <input
          type="date"
          name="startDate"
          id="startDate"
          value={startDate || ''}
          onChange={(e) => onDateRangeChange(e.target.value || null, endDate)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
        />
      </div>
      <div className="w-full sm:w-1/2">
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          {endDateLabel}
        </label>
        <input
          type="date"
          name="endDate"
          id="endDate"
          value={endDate || ''}
          onChange={(e) => onDateRangeChange(startDate, e.target.value || null)}
          min={startDate || undefined}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
